package com.narbase.narnic.trial.utils.popup

import com.narbase.kunafa.core.components.source
import com.narbase.kunafa.core.components.verticalLayout
import com.narbase.kunafa.core.components.video
import com.narbase.kunafa.core.components.view
import com.narbase.kunafa.core.css.*
import com.narbase.kunafa.core.dimensions.percent
import com.narbase.kunafa.core.dimensions.px
import com.narbase.kunafa.core.dimensions.vh
import com.narbase.kunafa.core.dimensions.vw
import com.narbase.kunafa.core.drawable.Color

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2019] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 2020/09/05.
 */
object VideoViewer {

    fun show(videoUrl: String, backgroundThumbnail: String? = null) {
        showInternalViewer(videoUrl, backgroundThumbnail)
    }

    private fun showInternalViewer(videoUrl: String, backgroundThumbnail: String? = null) {
        PopUpDialog.pdfViewer.showDialog {
            verticalLayout {
                style {
                    width = 80.vw
                    maxHeight = 90.vh
                    borderRadius = 16.px
                    overflow = "hidden"
                    backgroundColor = Color(0, 0, 0, 0.1)
                    position = "relative"

                }
                backgroundThumbnail?.let {
                    view {
                        style {
                            content = "";
                            position = "absolute";
                            top = 0.px
                            left = 0.px
                            right = 0.px
                            bottom = 0.px
                            backgroundImage = "url($it)"
                            backgroundSize = "cover";
                            filter = "blur(8px)"
                            zIndex = -1
                            backgroundPosition = "50% 50%"
                        }
                    }
                }
                video {
                    style {
                        width = 100.percent
                        maxHeight = 100.percent
                    }
                    element.setAttribute("controls", "true")
                    element.setAttribute("autoplay", "true")
                    element.setAttribute("type", "video/mp4")
                    source {
                        element.setAttribute("src", videoUrl)
                        element.setAttribute("type", "video/mp4")
                    }

                }

            }
        }

    }
}